<template>
  <div class="search">
    <search-bar
      @updateSearchQuery="updateSearchQuery($event)"
      @updateFilter="updateFilter($event)"
      query-param-key="q"
      :search-query="searchQuery"
      :placeholder="messages.search"
      :submit-button-label="messages.submitButtonLabel"
      :query-params="queryParams"
    />

    <div class="search__main">
      <div v-if="this.isLoading" class="search__loading-spinner-wrapper">
        <span class="loading-spinner"></span>
      </div>
      <div v-else-if="errorMessage" class="status-message">
        <div class="status-message__content">
          <span class="h4">{{ errorMessage }}</span>
        </div>
      </div>

      <div class="search__results">
        <sources
          @updateFilter="updateFilter($event)"
          :sources="sources"
          :label="messages.searchFilter"
          :query-params="queryParams"
          query-param-key="search-category"
        />

        <span v-if="this.searchQuery && this.filteredDocsCount" class="search__count p--big">
          {{ this.filteredDocsCount }} {{ messages.searchResultsCount }}
          <span class="search__highlighted-text">{{ this.searchQuery }}</span>
        </span>

        <ul v-if="this.filteredDocs && this.filteredDocs.length > 0" class="search__list">
          <li v-for="(doc, index) in this.filteredDocs" class="search__item" v-bind:key="index">
            <doc
              @updateSearchQuery="updateSearchQuery($event)"
              :data="doc"
              :search-query="filters.search && filters.search.value ? filters.search.value : null"
              :search-page-link="searchPageLink"
            />
          </li>
        </ul>

        <pagination
          @updateFilter="updateFilter($event)"
          :docs-count="this.filteredDocsCount"
          :docs-per-page="docsPerPage"
          :label="messages.paginationButtonLabel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchBar from "./searchBar";
import pagination from "./pagination.vue";
import sources from "./sources.vue";
import doc from "./doc";
import { getDocs, populateSources } from "./utils";
import { updateQueryParam, updateUrl } from "../../utils/queryParams"

export default {
  name: "search",
  components: {
    searchBar,
    pagination,
    sources,
    doc,
  },
  props: {
    restUrl: {
      type: String,
    },
    searchPageLink: {
      type: String,
    },
    messages: {},
    docsPerPage: {
      type: Number,
      default: 10,
    }
  },
  data() {
    return {
      docs: [],
      sources: [],
      filters: [],
      filteredDocs: [],
      filteredDocsCount: null,
      searchQuery: "",
      queryParams: new URLSearchParams(window.location.search),
      isLoading: false,
      errorMessage: null
    };
  },
  methods: {
    updateSearchQuery(value) {
      const trimmedValue = value.trim();

      if(this.searchQuery.toLowerCase() === trimmedValue.toLowerCase()) return;

      this.searchQuery = trimmedValue;

      this.updateErrorMessage();
      this.resetFiltersValues(["sources", "pagination"]);
      this.docs = [];
      this.filteredDocs = [];
      this.sources = [];
      this.filteredDocsCount = null;

      if(!this.searchQuery) return;

      this.setLoadingStatus(true);

      getDocs(this.restUrl, this.searchQuery)
        .then(docs => {
          if(docs.length === 0)
            return this.updateErrorMessage("noDocs");

          this.docs = docs;
          this.filteredDocsCount = docs.length;
          this.sources = populateSources(docs);
          this.runFilters();
        })
        .catch(err => this.updateErrorMessage("server"))
        .finally(() => this.setLoadingStatus(false));
    },
    updateFilter(filter) {
      const filterName = Object.keys(filter)[0];
      let filters = { ...this.filters };

      filters[filterName] = filter[filterName];

      this.filters = filters;

      this.runFilters();
    },
    runFilters() {
      const filtersOrder = ["sources", "pagination"];
      let filteredDocs = [...this.docs];

      for (const filter of filtersOrder) {
        if (!this.filters[filter] ||  !this.filters[filter].handler || typeof this.filters[filter].handler !== "function")
          continue;

        filteredDocs = this.filters[filter].handler(filteredDocs);

        if (filter !== "pagination") this.filteredDocsCount = filteredDocs.length;
      }

      this.updateQueryParams();

      this.filteredDocs = filteredDocs;
    },
    resetFiltersValues(filterNames) {
      let filters = {...this.filters};

      for(const [filterName, filterObj] of Object.entries(filters)) {
        if(!filterNames.includes(filterName)) continue;

        filterObj.value = null;
      }

      this.filters = filters;

      this.updateQueryParams();
    },
    updateQueryParams() {
      for (const filterObj of Object.values(this.filters)) {
        if (!filterObj.queryParamKey) continue;

        updateQueryParam(this.queryParams, filterObj.queryParamKey, filterObj.value, false);
      }

      updateUrl(this.queryParams);
    },
    updateErrorMessage(type = null) {
      if(!type)
        return this.errorMessage = null;

      if (this.messages && this.messages[type]) this.errorMessage = this.messages[type];
    },
    setLoadingStatus(value) {
      this.isLoading = value;
    }
  },
  mounted() {},
};
</script>